// @flow
/* -----------------Globals--------------- */
import React from 'react';

/* -----------------UI--------------- */
import Avatar from '@material-ui/core/Avatar';

/* -----------------Icons--------------- */
import CalendarPlus from 'mdi-material-ui/CalendarPlus';
import ClockOutline from 'mdi-material-ui/ClockOutline';
import FolderOutline from 'mdi-material-ui/FolderOutline';
import HeartOutline from 'mdi-material-ui/HeartOutline';
import ShareOutline from 'mdi-material-ui/ShareOutline';
import WrenchOutline from 'mdi-material-ui/WrenchOutline';
import CalendarOutline from 'mdi-material-ui/CalendarOutline';

/* -----------------Types--------------- */
import {
  contentType,
  type ContentTypes,
  folderType,
  type FolderTypes,
} from 'common/types';

/* -----------------Assets--------------- */
import { StudyPackOutline, StudySet, QuestionSet } from '@components/icons';

const getContentIcon = (
  c: ?ContentTypes,
  className: *,
  bundleUrl?: ?string,
) => {
  switch (c) {
    case contentType.STUDY_SET:
      return <StudySet className={className} />;
    case contentType.QUESTION_SET:
      return <QuestionSet className={className} />;
    case contentType.FOLDER:
      return <FolderOutline className={className} />;
    case contentType.BUNDLE:
      return <Avatar src={bundleUrl} className={className} />;
    case contentType.SCHEDULE:
      return <CalendarOutline className={className} />;
    default:
      return <CalendarPlus />;
  }
};

const getSmartFolderIcon = (
  iconType: FolderTypes,
  className?: *,
  color?: string,
) => {
  switch (iconType) {
    case folderType.Favorites:
      return <HeartOutline className={className} color={color} />;
    case folderType.Created:
      return <WrenchOutline className={className} color={color} />;
    case folderType.StudyPacks:
      return <StudyPackOutline className={className} color={color} />;
    case folderType.Recent:
      return <ClockOutline className={className} color={color} />;
    case folderType.Shared:
      return <ShareOutline className={className} color={color} />;
    default:
      return <FolderOutline className={className} color={color} />;
  }
};

export {
  getContentIcon,
  getSmartFolderIcon,
};
